export default __webpack_public_path__ + "static/media/951613989115-3.bc47e47a.png";